import { Container, Loading } from "@fluidattacks/design";
import type { FC } from "react";
import { Fragment } from "react";

import { useFindingPolicies } from "./hooks";
import type { IAcceptance } from "./types";
import { filterData } from "./utils";
import { VulnerabilitiesPolicies } from "./vulnerability-policies";

const Acceptance: FC<IAcceptance> = ({
  organizationId,
}: Readonly<IAcceptance>): JSX.Element => {
  const { data, loading } = useFindingPolicies(organizationId);

  if (!data?.organization || loading)
    return (
      <Container
        alignItems={"center"}
        display={"flex"}
        justify={"center"}
        left={"50%"}
        position={"absolute"}
        top={"50%"}
      >
        <Loading size={"lg"} />
      </Container>
    );

  return (
    <Fragment>
      <VulnerabilitiesPolicies
        data={filterData(
          data.organization.findingPolicies,
          "ACCEPTED_UNDEFINED",
        )}
        organizationId={organizationId}
        userRole={data.organization.userRole}
        vulnerabilityTreatment={"ACCEPTED_UNDEFINED"}
      />
      <VulnerabilitiesPolicies
        data={filterData(data.organization.findingPolicies, "ACCEPTED")}
        organizationId={organizationId}
        userRole={data.organization.userRole}
        vulnerabilityTreatment={"ACCEPTED"}
      />
    </Fragment>
  );
};

export { Acceptance };
